module.exports = __webpack_public_path__ + "static/media/user-default.cf250c66.svg";